import React from 'react'
import PhoneNumber from '../../../shared/PhoneNumber'
import { Section } from 'src/components/shared/SectionV2'

const MoreQuestions = ({ phoneNumber }) => {
  return (
    <Section variant="primary" id="more-questions">
      <div className="flex flex-col gap-4">
        <Section.Typography
          variant="heading-large"
          data-testid="more-questions-title"
        >
          Have more questions?
        </Section.Typography>
        <Section.Typography
          variant="display-medium"
          data-testid="more-questions-text"
        >
          Call us now:
          <PhoneNumber
            href={`tel:${phoneNumber}`}
            text={phoneNumber}
            className="ml-2 text-red-850"
            isTrack={true}
            nav_link_section="Bottom section"
          />
        </Section.Typography>
      </div>
    </Section>
  )
}

export default MoreQuestions
